import React from "react"
import tw from "twin.macro"

export const Column = ({
  elem = "div",
  children,
  className,
  thin = false,
  ...props
}) => {
  const Elem = ({ tag: Wrapper = elem, children, ...props }) => {
    return (
      <Wrapper
        className={["site__column", className, thin ? "!max-w-3xl" : ""].join(
          " "
        )}
        tw="container px-5 w-full mx-auto"
        {...props}
      >
        {children}
      </Wrapper>
    )
  }

  return <Elem {...props}>{children}</Elem>
}

export const SkipLink = ({ href, children, ...props }) => (
  <a
    href={href}
    tabIndex={0}
    tw="absolute top[10] left-1/2 transform[translateX(-50%)] opacity-0 zIndex[-1] outline-none focus:opacity-100 focus:z-50 focus:color[var(--nova-orange)]"
    {...props}
  >
    {children}
  </a>
)
